import React, { PureComponent } from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import Heading, { SubHeading } from '../../../components/heading';
import SegmentedTranslate from '../../../hocs/segmented-translate';
import ColumnedSection from '../columned-section';
import calendar from './calendar.svg';
import email from './email.svg';
import walking from './walking.svg';

const ItemCounter = styled.span`
  font-size: 2em;
  text-align: center;
  font-family: DINCondensed-Regular;
  margin-right: 0.2em;
`;

const Background = styled.div`
  background: #f0f0f0;
  color: #111111;
`;

/**
 * Instruction item
 */
const ItemTitle = styled.div`
  align-items: center;
  display: flex;
  color: ${props => props.theme.primary};
`;

const ItemTitleText = styled.span`
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 0.25em;
`;

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 1em;
  background: white;
  border-radius: 0.2em;
`;

const ItemContent = styled.div``;

const ItemIcon = styled.div`
  width: 4em;
  flex-shrink: 0;
  text-align: center;
  margin: 0 1.5em 0 0.5em;
`;

const IconImage = styled.img`
  max-height: 3em;
  max-width: 3em;
`;

/**
 * Item subtext
 */
const ItemText = styled.p`
  white-space: pre-line;
  text-align: left;
  line-height: 1.5em;
  color: #4b4b4b;
  margin: 0;
`;

const Next = styled.div`
  margin: 0.8em auto;
  height: 0;
  width: 0;
  border: 1em solid ${props => props.theme.primary};
  border-right: 1em solid transparent;
  border-bottom: none;
  border-left: 1em solid transparent;
`;

const Item = ({ number, icon }) => {
  return (
    <ItemContainer>
      <ItemIcon>
        <IconImage alt={number} src={icon} />
      </ItemIcon>
      <ItemContent>
        <ItemTitle>
          <ItemCounter>{`0${number}`}</ItemCounter>
          <ItemTitleText>
            <SegmentedTranslate
              id={`landingPage.instructions.${number}.title`}
            />
          </ItemTitleText>
        </ItemTitle>
        <ItemText>
          <SegmentedTranslate id={`landingPage.instructions.${number}.text`} />
        </ItemText>
      </ItemContent>
    </ItemContainer>
  );
};

/**
 * Instruction section
 */
class Instruction extends PureComponent {
  render() {
    return (
      <Background>
        <ColumnedSection
          title={
            <div>
              <Heading>PARTICIPATE</Heading>
              <SubHeading>
                <Translate id="landingPage.instructions.subtitle" />
              </SubHeading>
            </div>
          }
        >
          <Item icon={calendar} number="1" />
          <Next />
          <Item icon={email} number="2" />
          <Next />
          <Item icon={walking} number="3" />
        </ColumnedSection>
      </Background>
    );
  }
}

export default Instruction;
